import { gql } from "@apollo/client";
import type { TaskStage, TaskVisibility } from "@/types";

export const CREATE_TASK_MUTATION = gql`
  mutation CreateTask($input: BackofficeCRMCreateTaskInput!) {
    createTask(input: $input) {
      code
      success
      message
      task {
        id
        name
        description
        stage
        visibility
        dueDate
        createdAt
        updatedAt
        author {
          id
          name
          email
        }
        assignedTo {
          id
          name
          email
        }
        teamTags {
          source
          name
        }
      }
    }
  }
`;

export type BackofficeCRMReferenceableInput = {
  referenceableId: string;
  referenceableType: string;
};

export type BackofficeCRMCreateTaskInput = {
  name: string;
  description: string;
  assignedToId?: string | null;
  teamTags?: string[];
  dueDate?: string | null;
  stage?: TaskStage;
  visibility?: TaskVisibility;
  references?: BackofficeCRMReferenceableInput[];
};

type CreateTaskResult = {
  id: string;
  name: string;
  description: string;
  stage: TaskStage;
  visibility: TaskVisibility;
  dueDate: string | null;
  createdAt: string;
  updatedAt: string;
  author: { id: string; name?: string; email?: string };
  assignedTo: { id: string; name?: string; email?: string } | null;
  teamTags?: { source: string; name: string }[];
};

export type BackofficeCRMTaskMutationResponse = {
  code: string;
  success: boolean;
  message: string | null;
  task: CreateTaskResult | null;
};

export type CreateTaskResponse = {
  createTask: BackofficeCRMTaskMutationResponse;
};
